let booleanStatus = (status: boolean): { [key: string]: boolean } => {
    return {
        status: status,
    };
};

/**
 * Datapoint configurations.
 */
export default {
    AutomaticRepliesDeclinedEventsCountInfo: {
        datapoint: {
            name: 'AutomaticRepliesDeclinedEventsCountInfo',
            customData: (count: number): { [key: string]: number } => {
                return {
                    count: count,
                };
            },
        },
    },
    AutomaticRepliesOnOffStatus: {
        datapoint: {
            name: 'AutomaticRepliesOnOffStatus',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesTimePeriodEnabled: {
        datapoint: {
            name: 'AutomaticRepliesTimePeriodEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesBlockCalendarEnabled: {
        datapoint: {
            name: 'AutomaticRepliesBlockCalendarEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesDeclineNewEnabled: {
        datapoint: {
            name: 'AutomaticRepliesDeclineNewEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesDeclineExistingEnabled: {
        datapoint: {
            name: 'AutomaticRepliesDeclineExistingEnabled',
            customData: booleanStatus,
        },
    },
};
